import { render, staticRenderFns } from "./RecetasMainCard.vue?vue&type=template&id=9930e328&"
import script from "./RecetasMainCard.vue?vue&type=script&lang=js&"
export * from "./RecetasMainCard.vue?vue&type=script&lang=js&"
import style0 from "./RecetasMainCard.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports